
























































import Vue, { PropType } from 'vue';

import {
  IDocumentRevision,
  IQuotePackageDocument,
  IQuoteProductDocument
} from '@/models';
import {
  ISystemError,
  ISystemErrorData,
  SystemError
} from '@/models/error/index';
import PDFViewer from '@/components/common/PDFViewer/PDFViewer.vue';
import { GetDocumentParameters } from 'pdfjs-dist/types/src/display/api';
import { blobToBase64 } from '@/utils/helpers';
import NoDataAvailablePlaceholder from '@/components/common/NoDataAvailablePlaceholder.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import { isEqual } from 'lodash';

interface Options extends InstanceType<typeof Vue> {
  $refs: {
    pdfViewer: InstanceType<typeof PDFViewer>;
  };
}

export default Vue.extend<Options>({ functional: false }).extend({
  name: 'QuoteDocumentPackageBuilderPDFViewer',

  props: {
    packageDocument: [Object] as PropType<IQuotePackageDocument>
  },

  components: {
    ErrorAlert,
    PDFViewer,
    NoDataAvailablePlaceholder
  },

  data() {
    return {
      loading: false,
      error: null as ISystemError | null,
      selectedSection: 0,
      isActive: false,
      source: null as GetDocumentParameters | null,
      isLoading: false,
      fetchError: null as null | ISystemError,
      document: null as IQuoteProductDocument | null,
      revision: null as IDocumentRevision | null,
      page: 1,

      isPDFRendered: false
    };
  },

  watch: {
    packageDocument: {
      handler(value) {
        if (value?.quote_document) {
          this.downloadDocumentRevisionFile(
            value!.quote_document.document.latest_revision
          );
        }
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    // get document revision file when opening
    downloadDocumentRevisionFile(revision: IDocumentRevision) {
      this.isLoading = true;
      this.clearErrors();
      this.$services.fileLoader
        .downloadFile(revision.file)
        .then(async data => {
          this.source = await blobToBase64(data);
        })
        .catch(error => {
          const systemErrorData: ISystemErrorData = {
            name: error.name,
            message: error.message
          };
          // TODO: LH 2024-07-23 - look into not reusing this code
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            systemErrorData.message = error.response.statusText;
            if (error.response.data.detail) {
              systemErrorData.detail = error.response.data.detail;
            }
          } else if (error.request) {
            // The request was made but no response was received (Can happen on 500 error)
            systemErrorData.detail =
              'There was an error in processing your request. Please check with IT Admin';
          }

          this.fetchError = new SystemError(systemErrorData);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    clearErrors() {
      this.fetchError = null;
    }
  }
});
